import { render, staticRenderFns } from "./AjoutCategorie.vue?vue&type=template&id=6c0de1da&"
import script from "./AjoutCategorie.vue?vue&type=script&lang=js&"
export * from "./AjoutCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports